export default ({ i18n }) => ({
  ASSIGNED_TEXT: i18n.t`Assigned`,
  CLASS_TEXT: i18n.t`Class`,
  CURRENTLY_TEXT: i18n.t`Currently`,
  CURRENT_ASSIGNMENTS_TEXT: i18n.t`Current Assignments`,
  GROUP_TEXT: i18n.t`Group`,
  SELECT_STUDENT_TEXT: i18n.t`Select Student`,
  STUDENTS_TEXT: i18n.t`Students`,
  CURRENTLY_ASSIGNED_TEXT: i18n.t`Currently Assigned`
});
